import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

const pageType = "dealership enquiry"
const componentType = "dealership enquiry"

export const breadcrumbAnalytics = navItem => {
  const link = navItem?.url
    ? (navItem.url.indexOf("http") === -1 ? window.location.origin : "") +
      navItem.url
    : "n/a"

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:hero banner:breadcrumb`,
    eventName: `${pageType}:hero banner:breadcrumb`,
    eventType: "navigation",
    internalLinkName: "home",
    internalLinkPosition: pageType,
    internalLinkType: `${pageType}:breadcrumb`,
    internalLinkZoneName: `${pageType}:hero banner`,
    internalLinkURL: link ?? "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const getOtpAnalytics = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:form:get otp`,
    eventName: `${pageType}:form:get otp`,
    eventType: "navigation",
    internalLinkName: "get otp",
    internalLinkPosition: pageType,
    internalLinkType: `${pageType}:navigation`,
    internalLinkZoneName: `${pageType}:form`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const editMobileAnalytics = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:form:mobile number:edit`,
    eventName: `${pageType}:form:mobile number:edit`,
    eventType: "navigation",
    internalLinkName: "edit",
    internalLinkPosition: pageType,
    internalLinkType: `${pageType}`,
    internalLinkZoneName: `${pageType}:form:mobile number`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const submitEnquiryAnalytics = (payload, status, statusMsg) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:form:submit`,
    eventName: `${pageType}:form:submit`,
    eventStatus: status,
    eventMsg: statusMsg ?? "n/a",
    eventType: "navigation",
    internalLinkName: "submit",
    internalLinkPosition: pageType,
    internalLinkType: `${pageType}:navigation`,
    internalLinkZoneName: `${pageType}:form`,
    internalLinkURL: "n/a",
    selectedCity: payload?.city?.toLowerCase() ?? "",
    selectedSpaceAvailable: payload?.spaceAvailable?.toLowerCase() ?? "",
    selectedBudget: payload?.budget?.toLowerCase() ?? "",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const cancelEnquiryAnalytics = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:form:cancel`,
    eventName: `${pageType}:form:cancel`,
    eventType: "navigation",
    internalLinkName: "cancel",
    internalLinkPosition: pageType,
    internalLinkType: `${pageType}:navigation`,
    internalLinkZoneName: `${pageType}:form`,
    internalLinkURL: "n/a",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const backToHomeAnalytics = link => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:main content area:back to homepage`,
    eventName: `${pageType}:main content area:back to homepage`,
    eventType: "navigation",
    internalLinkName: "back to homepage",
    internalLinkPosition: pageType,
    internalLinkType: `${pageType}:navigation`,
    internalLinkZoneName: `${pageType}: main content area`,
    internalLinkURL: link,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const privacyStatementAnalytics = (text, link) => {
  const eventInfo = {
    clickInternalLinks: "false",
    eventAction: `${pageType}:form:${text}`,
    eventName: `${pageType}:form:${text}`,
    eventType: "navigation",
    internalLinkName: text,
    internalLinkPosition: pageType,
    internalLinkType: `${pageType}:navigation`,
    internalLinkZoneName: `${pageType}:form`,
    internalLinkURL: link,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
